import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import NotificationTemplate from './notification-template';
import NotificationTemplateDetail from './notification-template-detail';
import NotificationTemplateUpdate from './notification-template-update';
import NotificationTemplateDeleteDialog from './notification-template-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={NotificationTemplateUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={NotificationTemplateUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={NotificationTemplateDetail} />
      <ErrorBoundaryRoute path={match.url} component={NotificationTemplate} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={NotificationTemplateDeleteDialog} />
  </>
);

export default Routes;
